var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition-group",
        { attrs: { name: "list-transition", tag: "div" } },
        _vm._l(_vm.wishListItems, function(wishListItem) {
          return _c("wish-list-item", {
            key: wishListItem.id,
            attrs: {
              "wish-list-item-raw": wishListItem,
              "item-details-data": _vm.itemDetailsData
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mt-5 mb-0" }, [
        _vm.inactiveVariationIds.length !== 0
          ? _c("p", { staticClass: "h4" }, [
              _vm._v(
                _vm._s(_vm.$translate("Ceres::Template.wishListInactiveItems"))
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        { attrs: { name: "list-transition", tag: "div" } },
        _vm._l(_vm.inactiveVariationIds, function(wishListInactiveItem) {
          return _c("wish-list-inactive-item", {
            key: wishListInactiveItem,
            attrs: {
              "wish-list-inactive-item-raw": wishListInactiveItem,
              "item-details-data": _vm.itemDetailsData
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      (!_vm.isLoading &&
        (!_vm.wishListItems || _vm.wishListItems.length === 0)) ||
      _vm.inactiveVariationIds.length !== 0
        ? _c("p", { staticClass: "h4 text-muted text-center my-5" }, [
            _vm._v(_vm._s(_vm.$translate("Ceres::Template.wishListNoItems")))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading ? _c("loading-animation") : _vm._e(),
      _vm._v(" "),
      _vm.wishListItems && _vm.wishListItems.length
        ? _c("div", { staticClass: "vat small text-muted" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$translate("Ceres::Template.itemFootnote")) +
                " "
            ),
            _vm.showNetPrices
              ? _c("span", [
                  _vm._v(_vm._s(_vm.$translate("Ceres::Template.itemExclVAT")))
                ])
              : _c("span", [
                  _vm._v(_vm._s(_vm.$translate("Ceres::Template.itemInclVAT")))
                ]),
            _vm._v(
              "\n    " +
                _vm._s(_vm.$translate("Ceres::Template.itemExclusive")) +
                "\n    "
            ),
            _vm.$ceres.config.global.shippingCostsCategoryId > 0
              ? _c(
                  "a",
                  {
                    staticClass: "text-appearance",
                    attrs: { "data-toggle": "modal", href: "#shippingscosts" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Ceres::Template.itemShippingCosts")
                      )
                    )
                  ]
                )
              : _c(
                  "a",
                  {
                    attrs: {
                      title: _vm.$translate("Ceres::Template.itemShippingCosts")
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Ceres::Template.itemShippingCosts")
                      )
                    )
                  ]
                )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }